export default __webpack_public_path__ + "static/media/note.c46a2db3.png";